// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".uwpL5MYbn7Cbua {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 0;\n}\n.qsdK22tq2XU8e_ {\n  flex-grow: 1;\n  font-size: 14px;\n  line-height: 24px;\n  padding-right: 25px;\n}\n._18ou22kropp-ka {\n  margin: 0 0 0 20px;\n  flex-shrink: 0;\n}\n._18ou22kropp-ka button {\n  margin-top: 0;\n  margin-right: 0;\n  cursor: pointer;\n}\n._18ou22kropp-ka button:hover {\n  background-color: #C1C7D0;\n}\n._18ou22kropp-ka button:active {\n  background-color: #B3BAC5;\n  color: #172b4d;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noticeBannerContainer": "uwpL5MYbn7Cbua",
	"textContent": "qsdK22tq2XU8e_",
	"learnMoreButton": "_18ou22kropp-ka"
};
export default ___CSS_LOADER_EXPORT___;
